window.jQuery = window.$ = require("../../../../../../../storefront-reference-architecture/node_modules/jquery");
var processInclude = require("base/util");
const { GAService, BrazeSdkService } = require('sfcc-shared-react/lib/sfcc-shared-react/src/services');

$(document).ready(function() {
    processInclude(require("./components/menu"));
    processInclude(require('./components/promoBar'));
    processInclude(require("base/components/cookie"));
    processInclude(require("./components/consentTracking"));
    processInclude(require("./components/footer"));
    processInclude(require("./components/miniCart"));
    processInclude(require("base/components/collapsibleItem"));
    processInclude(require("./components/search"));
    processInclude(require("base/components/clientSideValidation"));
    processInclude(require("base/components/countrySelector"));
    processInclude(require("base/components/toolTip"));
    processInclude(require("./components/dataLayer"));
    processInclude(require("./reactEventBridge"));
});

window.GAService = GAService;
window.BrazeSdkService = BrazeSdkService;

require("base/thirdParty/bootstrap");
require("base/components/spinner");
require("./components/addToCart").addToCart();
require("./components/googleAnalytics").initializeEvents();
require("./components/brazeSdk").initializeEvents(window.brazeSdk.user);
